// extracted by mini-css-extract-plugin
export default {"text_section":"lazyText_text_section__fmozM","visible":"lazyText_visible__c7OP2"};